import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';

interface SearchProps {
  value: string;
  placeholder: string;
  onValueChange: (value: string) => void;
}

const Search: React.FC<SearchProps> = ({
  value,
  onValueChange,
  placeholder
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onValueChange(value);
    setInputValue(value);
  };

  const handleClearSearch = () => {
    onValueChange('');
    setInputValue('');
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{
        width: '100%',
        paddingBottom: '4px'
      }}
    >
      <i
        className="fa fa-search"
        style={{ color: 'grey', fontSize: '14px', marginRight: '8px' }}
      />
      <input
        ref={searchInputRef}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder={placeholder}
        className="tag-select-panel-search"
      />
      {inputValue !== '' && (
        <i
          className="fa fa-times"
          onClick={handleClearSearch}
          style={{
            marginLeft: '8px',
            cursor: 'pointer',
            color: 'grey',
            fontSize: '14px'
          }}
        />
      )}
    </Box>
  );
};

export default Search;
